/**
 * TimesRoteamentoPage — Configuração → Times & Roteamento (Item 366 Fase 4).
 *
 * Rota: /admin/atendimento/times-roteamento. CRUD de times + membership + regras de
 * roteamento sobre /v1/team-configs + /v1/routing-rules. Padrão D-B: gate próprio
 * (`team-config-read`) além da query gateada nos hooks. Mutações de times/membros
 * gateadas em `team-config-manage` na view; regras em `playbook-author`.
 */

import { CapabilityLockedBanner } from '@lume/ui-components';

import { TimesRoteamentoView } from '../features/team-config/TimesRoteamentoView';
import { useCapability } from '../hooks/use-capability';

import '../features/team-config/times-roteamento.css';

export function TimesRoteamentoPage(): JSX.Element {
  const canRead = useCapability('team-config-read');
  const canManage = useCapability('team-config-manage');

  if (!canRead) {
    return (
      <div className="times-roteamento-screen times-roteamento-screen--gate">
        <CapabilityLockedBanner
          capability="team-config-read"
          tierMin="team"
          fallbackMessage="A configuração de times e roteamento é restrita a perfis de supervisão/gestão do tenant."
        />
      </div>
    );
  }

  return <TimesRoteamentoView canManage={canManage} />;
}
